import { Box,  } from "@mui/material";
import OrgUsersRoleTable from "./OrgUserRole.table";
import OrgUsersLicenseTable from "./OrgUsersLicense.table";

const OrgUsersDetailsPanel = ({ row, selectedTable }) => {

  return (
    <Box>
      {selectedTable === "Roles" ? (
         <OrgUsersRoleTable row={row} />
      ) : (
         <OrgUsersLicenseTable row={row} source="organization"/>
      )}
    </Box>
  );
};

export default OrgUsersDetailsPanel;
